import template from './template.html'

function ContabilidadReporteisnLauncherComponent () {
}

angular.module('contabilidad.reporteisn')
  .component('contabilidadReporteisnLauncher', {
    controller: ContabilidadReporteisnLauncherComponent,
    template,
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/components/launcher/component.js